export const INCREMENT_POST_LIKE_COUNT_REQUEST = 'post/INCREMENT_LIKE_COUNT_REQUEST';
export const INCREMENT_POST_LIKE_COUNT_SUCCESS = 'post/INCREMENT_LIKE_COUNT_SUCCESS';
export const INCREMENT_POST_LIKE_COUNT_FAILURE = 'post/INCREMENT_LIKE_COUNT_FAILURE';
